/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./copyClipboard.vue?vue&type=template&id=d455cabe&scoped=true&"
import script from "./copyClipboard.vue?vue&type=script&lang=js&"
export * from "./copyClipboard.vue?vue&type=script&lang=js&"
import style0 from "./copyClipboard.vue?vue&type=style&index=0&id=d455cabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d455cabe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
